module.exports = __webpack_public_path__ + "static/media/youtube.6134b7e7.svg";